import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Inline DUPR edit for the player's Personal Details page.
export function DuprEditor() {
  const { user, setUser } = useAuth();
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  const has = !!user?.dupr_rating;

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/me/dupr", { dupr_rating: val.trim(), skipped: false });
      setUser({ ...user, dupr_rating: data.dupr_rating, dupr_prompt_done: true, dupr_prompt_done_at: new Date().toISOString() });
      toast.success("DUPR rating updated");
      setEditing(false);
    } catch { toast.error("Couldn't save — try again"); }
    finally { setBusy(false); }
  };

  return (
    <section className="card-surface p-6" data-testid="pd-dupr-rating">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="label-mono text-[#A3A3A3]">DUPR RATING</span>
        {!editing && (has
          ? <span className="h-display text-2xl tracking-tighter text-white" data-testid="pd-dupr-value">{user.dupr_rating}</span>
          : <span className="text-xs text-[#737373]">Not added</span>)}
        {!editing && (
          <button type="button" onClick={() => { setVal(user?.dupr_rating || ""); setEditing(true); }} data-testid="pd-dupr-edit"
            className="ml-auto text-[10px] uppercase tracking-wider px-3 py-1.5 border border-[#CCFF00] text-[#CCFF00] hover:bg-[#CCFF00] hover:text-black transition-colors">
            {has ? "Edit" : "Add"}
          </button>
        )}
      </div>
      {editing && (
        <div className="mt-3 flex flex-wrap gap-2">
          <input value={val} onChange={(e) => setVal(e.target.value)} maxLength={40} placeholder="e.g. 3.62" autoFocus data-testid="pd-dupr-input"
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); if (val.trim()) save(); } }}
            className="flex-1 min-w-[140px] bg-[#141414] border border-[#262626] focus:border-[#CCFF00] focus:outline-none p-2 text-sm text-white" />
          <button type="button" onClick={() => setEditing(false)} disabled={busy} data-testid="pd-dupr-cancel"
            className="px-4 py-2 text-xs uppercase tracking-wider text-[#A3A3A3] hover:text-white">Cancel</button>
          <button type="button" onClick={save} disabled={busy || !val.trim()} data-testid="pd-dupr-save"
            className="min-h-[40px] px-4 py-2 text-xs uppercase tracking-wider font-bold bg-[#CCFF00] text-black disabled:opacity-40">Save</button>
        </div>
      )}
    </section>
  );
}
